import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class P2SettingService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves the value for the setting with the given setting keyno.
     *
     * @datatask 3971
     * @datataskName sp_ws_p2_f_setting_get_ws
     * @param params the keyno of the setting to get.
     * @returns promise containing the value for the given setting keyno.
     */
    public async getP2SettingValue(params: GetSettingParams): Promise<'1' | '0'> {
        return (await this.datatask.Post(3971, params))[0].setting_value;
    }
}

export interface GetSettingParams {
    p2_setting_keyno: number | `${number}`;
}
